import React from 'react';
import HeroSVG from './hero.svg';

const HeroImage = () => (
  <HeroSVG />
);

export default HeroImage;
